<template>
  <div class="appointment_main">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('021003001') !== -1"/>
      </div>
      <input-search placeholder="设备名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @lookOver="lookOver" @changePagination="changePagination" @changeSelection="changeSelection" @goToModifyPage="toModifyPage" :operationArr="operationArr" @deleteLine="deleteLine" deleteTipInfo="是否确认删除该设备" />

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">
            <div style="text-align: left;margin: 10px 0 20px 0;">
              <el-date-picker v-model="hydraulicTimeArr" size="small" type="datetimerange"
                              :picker-options="pickerOptions2" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <table-main :selection="false" :hasOperation="false" :tableHead="hydraulicTableHead" :tableData="hydraulicTableData" :total="hydraulicTotal" :pageNum="hydraulicPageNum" :pageSize="hydraulicPageSize" @changePagination="changeHydraulicPagination"/>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/FireControl";
import { errorHandler } from "../../../../utils/errorHandler";
import ButtonConfirmNext from "../../../../components/Button/ButtonConfirmNext";
import { nAlert, nSuccess } from "../../../../utils/notice";
import ButtonAdd from "../../../../components/common/buttons/button-add";
import { bus } from "../../../../utils/bus";

export default {
  components: {
    ButtonAdd,
    ButtonConfirmNext,
    TableMain,
    InputSearch,
    Breadcrumb
  },
  name: "level-device-manage",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧消防",
          name: "fire-over-view"
        },
        {
          value: "液压设备"
        }
      ],
      tableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "parentName",
          label: "关联网关"
        },
        {
          prop: "buildingName",
          label: "所属楼栋"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        {
          prop: "minimumThreshold",
          label: "最小阈值"
        },
        {
          prop: "maximumThreshold",
          label: "最大阈值"
        },
        {
          prop: "theCurrentValue",
          label: "当前值"
        },
        {
          prop: "deviceStatus",
          label: "设备状态",
          isStatus: true
        },
        {
          prop: "alarmStatusOnPage",
          label: "报警状态",
          isStatus: true
        },
        {
          isLooking: true,
          label: "历史报警",
          width: "80"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      requestData: {
        pageNum: 1,
        pageSize: 10,
        deviceType: "2",
        startTime: "",
        endTime: "",
        searchKey: ""
      },

      selectionArr: [],

      windowLeftBox: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      hydraulicTableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceTypeText",
          label: "报警类型"
        },
        {
          prop: "numericalValue",
          label: "报警数值"
        },
        {
          prop: "uploadTime",
          label: "报警时间"
        },
        {
          prop: "processingCycle",
          label: "处理周期(分钟)"
        },
        {
          prop: "alarmReleaseTime",
          label: "报警解除时间"
        }
      ],
      hydraulicTableData: [],
      hydraulicDeviceCode: "",
      hydraulicTotal: 0,
      hydraulicPageSize: 10,
      hydraulicPageNum: 1,
      hydraulicTimeArr: []
    };
  },
  created() {
    this.getPage();
    this.getCreateTime();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getPage();
  },
  methods: {
    toAddPage() {
      this.$router.push({
        name: "level-device-add"
      });
    },
    toModifyPage(code) {
      this.$router.push({
        path: "/level_device_modify/" + code
      });
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getHydraulicDevicePage, reqData)
        .then(res => {
          let list = res.data.data.list;
          list.map(v => {
            v.code = v.deviceCode;
            if (v.alarmStatus === "0") {
              v.alarmStatusOnPage = "1";
            } else {
              v.alarmStatusOnPage = "0";
            }
          });
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },

    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteSelection() {
      if (this.selectionArr.length === 0) {
        nAlert("请先选择需要删除的设备");
        return false;
      } else {
        this.$confirm("是否确认删除所选中的设备？", "提示")
          .then(() => {
            this.deleteLine(this.selectionArr);
          })
          .catch(() => {
            console.log("取消删除");
          });
      }
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteHydraulicDevice, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },

    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.hydraulicTimeArr[0] =
        year + "-" + month + "-" + date + " " + "00:00:00";
      this.hydraulicTimeArr[1] =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;
    },
    changeHydraulicPagination(data) {
      this.hydraulicPageNum = data[0];
      this.hydraulicPageSize = data[1];
      this.getHydraulicPage();
    },
    // 查询报警记录
    lookOver(row) {
      this.hydraulicDeviceCode = row.code;
      this.getHydraulicPage();
    },
    getHydraulicPage() {
      let startTime = "";
      let endTime = "";
      if (this.hydraulicTimeArr) {
        if (this.hydraulicTimeArr.length > 1) {
          startTime = this.hydraulicTimeArr[0];
          endTime = this.hydraulicTimeArr[1];
        }
      }
      this.$axios
        .post(api.getAlarmRecordByDevice, {
          pageSize: this.hydraulicPageSize,
          pageNum: this.hydraulicPageNum,
          startTime: startTime,
          endTime: endTime,
          deviceCode: this.hydraulicDeviceCode
        })
        .then(res => {
          let data = res.data.data;
          data.list.map(v => {
            if (v.deviceType === "1") {
              v.deviceTypeText = "液位";
            } else if (v.deviceType === "2") {
              v.deviceTypeText = "液压";
            } else if (v.deviceType === "3") {
              v.deviceTypeText = "烟感";
            }
          });
          this.hydraulicTableData = data.list;
          this.hydraulicTotal = data.total;
          this.windowLeftBox = true;
        })
        .catch(errorHandler("查询失败"));
    }
  },
  watch: {
    hydraulicTimeArr(val) {
      this.getHydraulicPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.appointment_main {
  .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
    /*width: 50%!important;*/
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }
  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }

  form {
    width: 450px;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text {
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }
  .line-info {
    width: 220px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }
    form {
      position: relative;
      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }
      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 150px;
        line-height: 160px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
  .drawerBtnBox {
    width: 360px;
    padding-right: 60px;
    margin: 40px auto 0;
    .btn-confirm {
      border: 0;
      color: #fff;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
      margin-right: 60px;
    }
    .btn-confirm:hover {
      color: #fff;
      background-color: #06b3ff;
    }
    .reject-button {
      border: 0;
      background-color: #f25721;
      color: #ffffff;
      border-radius: 4px;
    }
    .reject-button:hover {
      background-color: #f96e3d;
    }
  }
}

.el-dialog__body {
  .el-table .cell {
    text-align: center;
  }
  .el-table th > .cell {
    color: #48576a;
    font-weight: bold;
  }
}
.el-dialog {
  .el-dialog .el-dialog__body .el-table__empty-block {
    margin: 0 auto;
  }
  .el-table__empty-text {
    width: auto;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    .el-table th:first-child {
      width: auto !important;
    }
  }
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/FireControl/FireControlDeviceManage/LevelDeviceManage/LevelDeviceManage.vue